/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_DisclaimerInputs */

const en_landing_hero_disclaimer = /** @type {(inputs: Landing_Hero_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No credit card required · Human review before submission · EU AI governance controls`)
};

const de_landing_hero_disclaimer = /** @type {(inputs: Landing_Hero_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Kreditkarte erforderlich · Menschliche Kontrolle vor jeder Einreichung · EU-KI-Governance-Kontrollen`)
};

const fr_landing_hero_disclaimer = /** @type {(inputs: Landing_Hero_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune carte de crédit requise · Propulsé par l'IA européenne · Données traitées dans l'UE`)
};

const es_landing_hero_disclaimer = /** @type {(inputs: Landing_Hero_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin tarjeta de crédito requerida · Impulsado por IA europea · Datos procesados en la UE`)
};

const it_landing_hero_disclaimer = /** @type {(inputs: Landing_Hero_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna carta di credito richiesta · Alimentato da AI europea · Dati elaborati nell'UE`)
};

const nl_landing_hero_disclaimer = /** @type {(inputs: Landing_Hero_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen creditcard vereist · Aangedreven door Europese AI · Gegevens verwerkt in de EU`)
};

const pl_landing_hero_disclaimer = /** @type {(inputs: Landing_Hero_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karta kredytowa nie jest wymagana · Zasilane przez europejskie AI · Dane przetwarzane w UE`)
};

const fi_landing_hero_disclaimer = /** @type {(inputs: Landing_Hero_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei luottokorttia -- eurooppalaisen tekoaelyn kayttoon -- tiedot kasitelty EU:ssa`)
};

const da_landing_hero_disclaimer = /** @type {(inputs: Landing_Hero_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intet kreditkort paakraevet · Drevet af europaeisk AI · Data behandlet i EU`)
};

const sv_landing_hero_disclaimer = /** @type {(inputs: Landing_Hero_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inget kreditkort kravs · Drivet av europeisk AI · Data behandlad i EU`)
};

/**
* | output |
* | --- |
* | "No credit card required · Human review before submission · EU AI governance controls" |
*
* @param {Landing_Hero_DisclaimerInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_hero_disclaimer = /** @type {((inputs?: Landing_Hero_DisclaimerInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_DisclaimerInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_hero_disclaimer(inputs)
	if (locale === "fr") return fr_landing_hero_disclaimer(inputs)
	if (locale === "es") return es_landing_hero_disclaimer(inputs)
	if (locale === "it") return it_landing_hero_disclaimer(inputs)
	if (locale === "nl") return nl_landing_hero_disclaimer(inputs)
	if (locale === "pl") return pl_landing_hero_disclaimer(inputs)
	if (locale === "fi") return fi_landing_hero_disclaimer(inputs)
	if (locale === "da") return da_landing_hero_disclaimer(inputs)
	if (locale === "sv") return sv_landing_hero_disclaimer(inputs)
	return en_landing_hero_disclaimer(inputs)
});